<template>
  <div>
    <div class="col py-2 row justify-content-between align-items-center">
      <span class="col-11 row">
        <v-icon>event</v-icon>
        <p class="m-0 ml-2">{{$store.state.user.langEng ? 'All day' : 'Hela dagen'}}</p>
      </span>
      <v-switch v-model="allDay" class="col-1"></v-switch>
    </div>
    <div class="date-pickers pr-2" :class="{'date-error' : dateError}">
      <article-time-picker
        :disable="allDay"
        :setTime="startTime"
        @newDateTime="setStartTime($event)"
        :hideIcons="true"
      />
      <article-time-picker
        :disable="allDay"
        :setTime="endTime"
        @newDateTime="setEndTime($event)"
        :hideIcons="true"
      />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ArticleTimePicker from "@/components/CreateArticle/ArticleTimePicker";

@Component({
  components: {
    ArticleTimePicker
  }
})
export default class CalendarDateTime extends Vue {
  @Prop() error;
  allDay = false;
  dateError = false;
  startTime = 0;
  endTime = 0;

  @Watch('allDay')
  watchAllDay(newVal) {
    if (newVal) {
      let newStart = new Date(this.startTime);
      newStart.setHours(10);
      this.setStartTime(newStart.getTime());
    }
    this.$store.commit('calendar/updateEditEvent', { allDay: newVal });
  }

  @Watch("error")
  watchSetDateError(val) {
    this.dateError = val;
  }

  @Watch("$store.state.calendar.editEventUpdate")
  watchShowAddEventDialog(val) {
    if (val) {
      this.setDateFromEvent();
    }
  }

  get event() {
    return this.$store.state.calendar.editEvent;
  }

  setStartTime(time) {
    this.dateError = false;
    const startIsAfterEnd = time >= this.event.end;
    const onlyChangedDate = !((this.event.start - time) % 86400000);

    if (onlyChangedDate) {
      this.endTime = this.changeDateAndKeepTime(time, "end");
    } else if (startIsAfterEnd) {
      // set starttime 30 minutes to endtime
      this.endTime = time + 1800000;
    }
    this.$store.commit("calendar/updateEditEvent", { start: time });
  }

  setEndTime(time) {
    this.dateError = false;
    const endIsBeforeStart = time <= this.event.start;
    const onlyChangedDate = !((this.event.end - time) % 86400000);

    if (onlyChangedDate && endIsBeforeStart) {
      this.startTime = this.changeDateAndKeepTime(time, "start");
    } else if (endIsBeforeStart) {
      // set starttime 30 minutes to endtime
      this.startTime = time - 1800000;
    }
    this.$store.commit("calendar/updateEditEvent", { end: time });
  }

  changeDateAndKeepTime(time, keep) {
    let newTime = new Date(time);
    let oldTime = new Date(this.event[keep]);
    newTime.setHours(oldTime.getHours());
    newTime.setMinutes(oldTime.getMinutes());
    return newTime;
  }

  setDefaultDate() {
    if (this.$route.params.day) {
      let p = this.$route.params;
      let d = new Date();
      d.setFullYear(p.year);
      d.setMonth(p.month - 1);
      d.setDate(p.day);

      // time is fixed to a future half hour
      if (d.getMinutes() > 30) {
        d.setHours(d.getHours() + 1);
        d.setMinutes(0);
      } else {
        d.setMinutes(30);
      }
      this.startTime = d.getTime();
      this.endTime = d.getTime() + 1800000;

      this.$store.commit("calendar/updateEditEvent", {
        start: this.startTime,
        end: this.endTime
      });
    }
  }

  setDateFromEvent() {
    if (this.event.start) {
      this.startTime = this.event.start;
      this.endTime = this.event.end;
    } else {
      this.setDefaultDate();
    }
  }

  mounted() {
    this.setDateFromEvent();
  }
}
</script>

<style lang="scss">
.date-pickers {
  padding-left: 2em;
  .date-time-picker {
    .v-text-field {
      padding-top: 0;
      margin: 0;
    }
    .time-pick {
      input {
        text-align: end !important;
      }
    }
    .v-input__slot {
      margin: 0;

      &::before {
        display: none;
      }
    }
  }
}
.date-error {
  border-radius: 4px;
  border: 2px solid rgba(255, 0, 0, 0.726);
  box-shadow: 0 0 5px 0 red;
}
</style>
